export default {
    $: 'Text',
    props: {
        fontSize: '0.6875rem',
        color: '#53585c',
        textAlign: 'center',
        px: { md: 13 },
        mt: 6,
    },
    children: ({ startText = 'By clicking “Continue” you agree to our ', termsLink = '#', privacyLink = '#', linkProps }) => [
        {
            $: 'Text', props: { as: 'span' }, children: startText,
        },
        {
            $: 'Link', props: { href: termsLink, target: '_blank', _focus: { boxShadow: 'none' }, ...linkProps }, children: 'Terms of Service',
        },
        {
            $: 'Text', props: { as: 'span' }, children: ' and ',
        },
        {
            $: 'Link', props: { href: privacyLink, target: '_blank', _focus: { boxShadow: 'none' }, ...linkProps }, children: 'Privacy Policy',
        },
    ],
}